class SignupTracking {
  constructor($cookies, $location, $social) {
    this.$cookies = $cookies;
    this.$location = $location;
    this.$social = $social;
  }

  makeMarketingString() {
    let marketingParams = [""];

    const cookies = this.$cookies.getAll();

    if (cookies.hubspotutk) {
      marketingParams.push(`hubspotutk=${cookies.hubspotutk}`);
    }

    const params = ["utm_campaign", "utm_medium", "utm_source", "utm_term", "utm_content"];
    const queryParams = this.$location.$$search || {};

    params.forEach((param) => {
      if (queryParams[param]) {
        marketingParams.push(`${param}=${queryParams[param]}`);
      }
    });

    return marketingParams.join("&");
  }

  fbTrackRegistration(response, user) {
    let data = {};
    data.userId = response.data.userId;
    data.userName = user.email;
    data.userEmail = user.email;
    this.$social.fbTrackRegistration(data);
  }

  initFB() {
    let index = this.$location.$$path.indexOf("/signup/jobbler");
    if (index > -1) {
      this.$social.initFB();
    }
  }
}

SignupTracking.$inject = ["$cookies", "$location", "social"];

export default SignupTracking;



// WEBPACK FOOTER //
// ./client/app/scenes/signup/services/tracking.js